import { render, staticRenderFns } from "./ModalPackageFeaturesUsers.vue?vue&type=template&id=f72a68d8&"
import script from "./ModalPackageFeaturesUsers.vue?vue&type=script&lang=js&"
export * from "./ModalPackageFeaturesUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports